module.exports = __webpack_public_path__ + "officialStatic/img/glLogo.cdeb7f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/glLogo.jpg
// module id = qQPU
// module chunks = 0